import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
import useRandomId from 'hooks/useRandomId';

const IconUltraDeepMaxComfort = ({
  color = colorGray,
  width = '49',
  height = '49',
  className = '',
}) => {
  const iconId = useRandomId('IconUltraDeepMaxComfort');
  const clipPathId = `${iconId}__clipPath`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M9.30886 19.6562V19.6562C8.45069 19.6563 7.72333 20.3619 7.67725 21.2469V31.0344C7.67725 31.9012 8.38862 32.6126 9.25545 32.6126H38.0562C38.923 32.6126 39.6344 31.9012 39.6344 31.0344V21.2344C39.6344 20.3676 38.923 19.6562 38.0562 19.6562H9.30886Z"
          stroke={color}
          strokeWidth="1.2"
        />
        <path
          d="M36.6331 14.5367C36.4446 14.3428 36.4444 14.0343 36.6325 13.8402L37.8615 12.5721H25.1385L26.3725 13.84C26.5614 14.0341 26.5614 14.3433 26.3725 14.5374L26.2806 14.6318C26.0843 14.8335 25.7602 14.8335 25.5639 14.6317L23.3396 12.3457C23.1506 12.1514 23.1508 11.8419 23.34 11.6479L25.5639 9.36744C25.7603 9.16608 26.0841 9.16624 26.2802 9.36779L26.3725 9.46258C26.5614 9.65668 26.5614 9.96593 26.3725 10.16L25.1385 11.4279H37.8615L36.6325 10.1598C36.4444 9.96569 36.4446 9.65716 36.6331 9.46332L36.7252 9.36854C36.9215 9.16667 37.2457 9.16658 37.442 9.36835L39.661 11.6483C39.8497 11.8422 39.8499 12.1512 39.6614 12.3453L37.442 14.6308C37.2457 14.833 36.9212 14.8331 36.7248 14.631L36.6331 14.5367Z"
          fill={color}
        />
        <path
          d="M8.6002 16.5015V16.5015L8.60003 19.4001H20.1073L17.2351 12.3586C16.584 10.8798 14.9432 10.2082 13.6084 10.8383L13.6018 10.8414L13.5952 10.8443L10.0084 12.4324C9.31774 12.7612 8.99884 13.1681 8.82171 13.7444C8.62409 14.3874 8.6002 15.2453 8.6002 16.5015Z"
          stroke={color}
          strokeWidth="1.2"
        />
        <line
          x1="7.6"
          y1="31"
          x2="7.6"
          y2="37"
          stroke={color}
          strokeWidth="1.2"
        />
        <line
          x1="39.6"
          y1="31"
          x2="39.6"
          y2="37"
          stroke={color}
          strokeWidth="1.2"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width={width}
            height={height}
            fill="white"
            transform="matrix(-1 0 0 1 49 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

IconUltraDeepMaxComfort.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconUltraDeepMaxComfort;
